import React from 'react';
import {useSelector} from 'react-redux';
import {useFormikContext} from 'formik';
import FormikCheckbox from 'src/components/formik-checkbox';
import FormikDatePicker from 'src/components/formik-date-picker';
import Label from 'shared/components/label';
import FormikTextArea from 'src/components/formik-text-area';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import {UserType} from 'src/types/enums';

const CommunityService = () => {
  const userType = useSelector((state) => state.userType);
  const formik = useFormikContext();

  return (
    <>
      <legend className="shared-required-legend"></legend>

      <Label required>
        Organization Name
        <FormikTextInput
          name="place"
          autoFocus={formik.values.new}
          placeholder="Organization Name"
          required
        />
      </Label>

      <FormikDatePicker
        monthLabel={formik.values.dateRange ? 'Start month' : undefined}
        monthName="startMonth"
        yearLabel={formik.values.dateRange ? 'Start year' : undefined}
        yearName="startYear"
        lastX={userType === UserType.HS_STUDENT ? 6 : 30}
        required
      />

      {formik.values.dateRange && (
        <FormikDatePicker
          monthLabel="End month"
          monthName="endMonth"
          yearLabel="End year"
          yearName="endYear"
          lastX={userType === UserType.HS_STUDENT ? 6 : 30}
          required
        />
      )}

      <FormikCheckbox name="dateRange" label="Enter a range" className="mt-12" />

      <Label required>
        Total Hours
        <FormikTextInput type="number" step=".1" name="hours" placeholder="Total Hours" required />
      </Label>

      <Label required>
        What did you do to help out?
        <FormikTextArea name="description" rows={2} placeholder="Describe your role" required />
      </Label>

      <FormikCheckbox name="requiredByHs" label="Required by my school" className="mt-12" />
    </>
  );
};

export default CommunityService;
